"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BSC_TOKEN_TICKERS = void 0;
const ticker_1 = require("./ticker");
exports.BSC_TOKEN_TICKERS = [
    ticker_1.Ticker.BUSD,
    ticker_1.Ticker.LTT,
    ticker_1.Ticker.AAVE,
    ticker_1.Ticker['1INCH'],
    ticker_1.Ticker.TLM,
    ticker_1.Ticker.ATA,
    ticker_1.Ticker.BAKE,
    ticker_1.Ticker.BCH,
    ticker_1.Ticker.ADA,
    ticker_1.Ticker.COMP,
    ticker_1.Ticker.DOGE,
    ticker_1.Ticker.FTM,
    ticker_1.Ticker.KNC,
    ticker_1.Ticker.LTC,
    ticker_1.Ticker.MATIC,
    ticker_1.Ticker.CAKE,
    ticker_1.Ticker.DOT,
    ticker_1.Ticker.XRP,
    ticker_1.Ticker.SFP,
    ticker_1.Ticker.SHIB,
    ticker_1.Ticker.SUSHI,
    ticker_1.Ticker.SNX,
    ticker_1.Ticker.TWT,
    ticker_1.Ticker.VET,
    ticker_1.Ticker.YFI,
    ticker_1.Ticker.USDC,
    ticker_1.Ticker.USDT,
    ticker_1.Ticker.VOLT,
    ticker_1.Ticker.ZEDXION,
    ticker_1.Ticker.ZEDXIONC,
    ticker_1.Ticker.USDZ,
    ticker_1.Ticker.IRR,
    ticker_1.Ticker.ATOM,
    ticker_1.Ticker.NEAR,
    ticker_1.Ticker.GMT,
    ticker_1.Ticker.SBX,
    ticker_1.Ticker.DONR,
    ticker_1.Ticker.INTD,
    ticker_1.Ticker.INTDv1,
    ticker_1.Ticker.FUNEX,
    ticker_1.Ticker.HLS,
    ticker_1.Ticker.SVR,
    ticker_1.Ticker.MOLT,
    ticker_1.Ticker.SHF,
    ticker_1.Ticker.OJS,
    ticker_1.Ticker.TGR,
    ticker_1.Ticker.CRED
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnNjLXRva2VuLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RpY2tlcnMvYnNjLXRva2VuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLHFDQUFpQztBQUVwQixRQUFBLGlCQUFpQixHQUFHO0lBQy9CLGVBQU0sQ0FBQyxJQUFJO0lBQ1gsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsSUFBSTtJQUNYLGVBQU0sQ0FBQyxPQUFPLENBQUM7SUFDZixlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsSUFBSTtJQUNYLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxLQUFLO0lBQ1osZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsSUFBSTtJQUNYLGVBQU0sQ0FBQyxLQUFLO0lBQ1osZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsSUFBSTtJQUNYLGVBQU0sQ0FBQyxJQUFJO0lBQ1gsZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsT0FBTztJQUNkLGVBQU0sQ0FBQyxRQUFRO0lBQ2YsZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxJQUFJO0lBQ1gsZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsSUFBSTtJQUNYLGVBQU0sQ0FBQyxNQUFNO0lBQ2IsZUFBTSxDQUFDLEtBQUs7SUFDWixlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLElBQUk7SUFDWCxlQUFNLENBQUMsR0FBRztJQUNWLGVBQU0sQ0FBQyxHQUFHO0lBQ1YsZUFBTSxDQUFDLEdBQUc7SUFDVixlQUFNLENBQUMsSUFBSTtDQUNaLENBQUEifQ==